"use client";

import { useWindowDimensions } from "@/components/hooks/window";
import { OptionsContext } from "@/provider/options-provider";
import dynamic from "next/dynamic";
import { Datum } from "plotly.js";
import { useContext } from "react";
const Plot = dynamic(() => import("react-plotly.js"), { ssr: false });

export function Histogram() {
  const { aggregations } = useContext(OptionsContext);
  const { breakpoint } = useWindowDimensions();

  const h = 70;
  const w = breakpoint === "sm" ? 310 : breakpoint === "lg" ? 700 : 800;

  const data =
    aggregations?.map((i) => {
      return {
        x: i.date_time,
        y: i.count,
      };
    }) ?? [];

  return (
    <Plot
      data={[
        {
          type: "bar",
          x: data.filter((d) => d.x !== undefined).map((d) => d.x),
          y: data.filter((d) => d.y !== undefined).map((d) => d.y) as Datum[],
        },
      ]}
      layout={{
        width: w,
        height: h,
        transition: { duration: 500, easing: "cubic-in-out" },
        template: {
          layout: {
            plot_bgcolor: "rgba(0,0,0,0)",
            paper_bgcolor: "rgba(0,0,0,0)",
            font: {
              color: "rgba(0,0,0,0.9)",
              size: 9,
            },
            margin: {
              l: 40,
              r: 5,
              b: 25,
              t: 0,
            },
            yaxis: {
              gridcolor: "rgba(0,0,0,0.04)",
            },
          },
        },
      }}
      className="relative overflow-hidden"
      config={{
        displayModeBar: false,
        responsive: true,
        staticPlot: false,
        displaylogo: false,
      }}
    />
  );
}
